<template>
  <BasePage :is_with_background="false">
    <LoadingFrame v-if="this.loadingTasks" />

    <div class="task_types" v-else>
      <LabelComponent v-if="this.task_types && this.task_types.length < 1"
                      label_type='h3'
                      :label_text="this.loc('Список пуст')"/>
      <div v-for="task_type in this.task_types" :key="task_type" class="task_types__group">
        <LabelComponent label_type='h3'
                        :label_text="this.loc(task_type) || ''"/>

        <ListView
            :is_loading="this.data_loading"
            :is_with_search="false"
            :search_data="this.current_data_calc.filter((xItem) => xItem['BusinessProcess'] === task_type)"
            @click_by_list_item="this.click_by_card">

          <template v-slot="{item}">
            <div class="card__header">
              <LabelComponent class="card__header__title"
                              label_type='button/large/regular 14'
                              :label_text="item['INN'] || ''"/>

              <LabelComponent label_type='button/large/regular 14'
                              :label_text="this.get_string_date(item['Deadline']) || ''"/>

              <LabelComponent label_type="body/large/regular 12"
                              :label_color="
                                  (item['TaskType'] === 'Согласовать') ? 'status-color-3':
                                  (item['TaskType'] === 'Ознакомиться') ? 'status-color-1' : undefined"
                              :label_text="item['TaskType'] || ''"/>
            </div>

            <SeparatorComponent/>

            <LabelComponent label_type='button/large/regular 14'
                            :label_text="item['Partner'] || ''"/>
          </template>
        </ListView>
      </div>
    </div>

    <template v-slot:modal>
      <ModalViewConductor ref="modalViewConductor">
        <ModalView v-if="this.task_form.selected_item != null"
                   :open_level="1"
                   type_modal="internal"
                   :caption="this.loc('Оставить комментарий')"
                   @click_close="this.closed_modal($event); this.$refs.modalViewConductor.close_level()">

          <BarLayout direct="vertical" gap="12" style="overflow: visible">
            <LabelComponent v-if="this.task_form.success_text" class="success_text"
                            label_type='body/large/regular 12'
                            :label_text="this.task_form.success_text"/>

            <LabelComponent v-if="this.task_form.error_text" class="error_text"
                            label_type='body/large/regular 12'
                            :label_text="this.task_form.error_text"/>

            <NamedField :label="this.loc('Партнер')">
              <LabelComponent label_type='button/large/regular 14'
                              :label_text="this.task_form.selected_item['Partner']"/>
            </NamedField>

            <SeparatorComponent/>

            <NamedField :label="this.loc('Предмет')">
              <LabelComponent label_type='button/large/regular 14'
                              :label_text="this.task_form.selected_item['Object']"/>
            </NamedField>

            <SeparatorComponent/>

            <NamedField :label="this.loc('ИНН')">
              <LabelComponent label_type='button/large/regular 14'
                              :label_text="this.task_form.selected_item['INN']"/>
            </NamedField>

            <SeparatorComponent/>

            <NamedField :label="this.loc('Автор задачи')">
              <LabelComponent label_type='button/large/regular 14'
                              :label_text="this.task_form.selected_item['Author']"/>
            </NamedField>

            <SeparatorComponent/>

            <NamedField :label="this.loc('Описание')">
              <div>
                <LabelComponent style="white-space: pre"
                                label_type='body/large/regular 12'
                                :label_text="this.task_form.selected_item['Description']"/>
              </div>
            </NamedField>

            <SeparatorComponent/>

            <NamedField :label="this.loc('Дата')">
              <LabelComponent label_type='button/large/regular 14'
                              :label_text="new Date(this.task_form.selected_item['Deadline']).toLocaleDateString()"/>
            </NamedField>

            <InputField type="textarea"
                        @input_change="this.set_comments"
                        :is_all_time_open="true"
                        :label_text="this.loc('Комментарий')"
                        :input_field_status="(this.task_form.error_text_comment) ? 'error' : undefined"
                        :error_text="this.task_form.error_text_comment"/>

            <CheckBoxComponent v-if="this.task_form.selected_item['ConfirmWithDirector'] !== undefined"
                               @input_check="confirmFormDirector"
                               :init_value="false"
                               :label_text_right="this.loc('Согласовать с директором')"/>
            <CheckBoxComponent v-if="this.task_form.selected_item['ConfirmWithFinancier'] !== undefined"
                               @input_check="confirmFormFinancier"
                               :init_value="false"
                               :label_text_right="this.loc('Согласовать с финансистом')"/>
            <CheckBoxComponent v-if="this.task_form.selected_item['SegmentUponShipment'] !== undefined"
                               @input_check="confirmFormSegmentUponShipment"
                               :init_value="false"
                               :label_text_right="this.loc('Включить партнера в сегмент \'По факту\'')"/>


            <div class="modal-button-panel">
              <ButtonComponent class="modal-button"
                               :label="this.loc(this.task_form.selected_item['TaskType'])"
                               :elementInLoading="this.task_form.is_button_loading_main"
                               @click_to_button="this.send_comment(true)"/>

              <ButtonComponent v-if="this.task_form.selected_item['TaskType'] === 'Согласовать'" class="modal-button"
                               :label="this.loc('Не согласовать')"
                               :elementInLoading="this.task_form.is_button_loading_additional"
                               elementStatusModifier="danger"
                               @click_to_button="this.send_comment(false)"/>
            </div>
          </BarLayout>
        </ModalView>
      </ModalViewConductor>
    </template>
  </BasePage>
</template>

<script>
import builder from '../../assets/v1/js/builder';
import FiltersWrapper from '@/components/unit/FiltersWrapper';
import BasePage from '../../components/navigation/BasePage';
import SeparatorComponent from '../../components/unit/Separator';
import BarLayout from '../../components/unit/BarLayout';
import LabelComponent from '../../components/unit/Label';
import ModalView from '../../components/ModalView';
import InputField from '../../components/unit/InputField';
import ButtonComponent from '../../components/unit/Button';
import ModalViewConductor from '../../components/navigation/ModalViewConductor';
import NamedField from '../../components/unit/NamedField';
import DropDownInput from '../../components/unit/DropDownInput';
import ListView from '../../components/unit/ListView';
import CheckBoxComponent from '../../components/unit/CheckBox';
import LoadingFrame from '../../components/LoadingFrame';
import {dataRequester, ROOT_URL} from '../../assets/v1/js/project_management/DataRequester';


export default builder({
  name: 'Sellers',
  components: {
    BasePage, BarLayout, SeparatorComponent,
    LabelComponent, ModalView, InputField, ButtonComponent,
    ModalViewConductor, NamedField, DropDownInput, ListView, CheckBoxComponent,
    LoadingFrame,
  },
  data: () => ({
    loadingTasks: true,
    presentationData: [
      {
        'id': 'c8a3f21b-ff33-11eb-80fd-a4bf016a73d1',
        'Number': '00-00009503007',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 \u041e\u041e\u041e "\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422" \u2116CH00-000188 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 CH00-000188 \u043e\u0442 17.08.2021 9:31:43',
        'Partner': '\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422 \u041e\u041e\u041e',
        'Author': '\u0428\u0435\u0440\u0435\u043c\u0435\u0442\u044c\u0435\u0432 \u0412\u0438\u043a\u0442\u043e\u0440',
        'INN': '5010056869',
        'Deadline': '2021-11-01T13:17:59',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a:\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422 \u041e\u041e\u041e (\u0418\u041d\u041d/\u041a\u041f\u041f:5010056869/501001001) \u043d\u0430 \u0441\u043a\u043b\u0430\u0434 \u041f\u043e\u043b\u0438\u043c\u0435\u0440\u044b Kartli International (\u0442\u043e\u0432\u0430\u0440\u044b \u0432 \u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0438)\n\u0411\u043b\u043e\u043a-\u0441\u043e\u043f\u043e\u043b\u0438\u043c\u0435\u0440 \u0421\u0411\u0421-330\u0420\t\t11 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0619,00\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f:\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430:\u041d\u0430 \u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0435 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0439 \u0441\u043b\u0443\u0436\u0431\u044b\n\u041a\u0440\u0435\u0434\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c:\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f:',
        'Comment': '',
      },
      {
        'id': 'e9ce88a9-ff32-11eb-80fd-a4bf016a73d1',
        'Number': '00-00009501007',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 \u041e\u041e\u041e "\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422" \u2116CH00-000189 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 CH00-000189 \u043e\u0442 17.08.2021 9:33:15',
        'Partner': '\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422 \u041e\u041e\u041e',
        'Author': '\u0428\u0435\u0440\u0435\u043c\u0435\u0442\u044c\u0435\u0432 \u0412\u0438\u043a\u0442\u043e\u0440',
        'INN': '5010056869',
        'Deadline': '2021-11-01T13:12:40',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a:\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422 \u041e\u041e\u041e (\u0418\u041d\u041d/\u041a\u041f\u041f:5010056869/501001001) \u043d\u0430 \u0441\u043a\u043b\u0430\u0434 \u041f\u043e\u043b\u0438\u043c\u0435\u0440\u044b Kartli International (\u0442\u043e\u0432\u0430\u0440\u044b \u0432 \u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0438)\n\u0411\u043b\u043e\u043a-\u0441\u043e\u043f\u043e\u043b\u0438\u043c\u0435\u0440 \u0421\u0411\u0421-330\u0420\t\t11 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0832,00\n\u0411\u043b\u043e\u043a-\u0441\u043e\u043f\u043e\u043b\u0438\u043c\u0435\u0440 \u0421\u0411\u0421-330\u041b\t\t16 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0832,00\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f:\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430:\u041d\u0430 \u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0435 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0439 \u0441\u043b\u0443\u0436\u0431\u044b\n\u041a\u0440\u0435\u0434\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c:\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f:',
        'Comment': '',
      },
      {
        'id': 'f9051eb7-ff4b-11eb-80fd-a4bf016a73d1',
        'Number': '00-00077161001',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043a\u043b\u0438\u0435\u043d\u0442\u0430 \u041e\u041e\u041e "\u041f\u041b\u0410\u0422\u0422\u0415\u041d" \u2116KR00-003287 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043a\u043b\u0438\u0435\u043d\u0442\u0430 KR00-003287 \u043e\u0442 17.08.2021 13:40:30',
        'Partner': '\u041f\u041b\u0410\u0422\u0422\u0415\u041d \u041e\u041e\u041e',
        'Author': '\u0413\u0430\u0431\u0434\u0440\u0430\u0445\u0438\u043c\u043e\u0432\u0430 \u0420\u0435\u0433\u0438\u043d\u0430',
        'INN': '7725494536',
        'Deadline': '2021-11-01T16:12:09',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043a\u043b\u0438\u0435\u043d\u0442\u0430',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u044f: \u041a\u0430\u0440\u0442\u043b\u0438 \u0420\u0443\u0441 \u041e\u041e\u041e\n\u0420\u0438\u0441\u043a\u043e\u0432\u0430\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u043d\u0430\u044f \u0434\u0438\u0441\u0446\u0438\u043f\u043b\u0438\u043d\u0430 \u0437\u0430 3 \u043c\u0435\u0441\u044f\u0446\u0430 (\u041d\u0430\u0446\u0435\u043d\u043a\u0430 \u0437\u0430 \u0440\u0438\u0441\u043a 2%)\n\u041f\u0415\u0420\u0415\u0420\u0410\u0411\u041e\u0422\u0427\u0418\u041a: \u041f\u041b\u0410\u0422\u0422\u0415\u041d \u041e\u041e\u041e (\u0418\u041d\u041d/\u041a\u041f\u041f:7725494536/772001001) \u043e\u0442 \u0421\u043a\u043b\u0430\u0434 \u0412\u0418\u0420\u0410-\u041d\u0427\n\u041a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439 \u043f\u043e \u043a\u043b\u0438\u0435\u043d\u0442\u0443: \u0421\u0435\u043a\u0442\u043e\u0440 \u041f\u042d/\u041f\u041f\n\u0415\u0441\u0442\u044c \u043d\u0435\u0441\u043a\u043e\u043c\u043f\u0435\u043d\u0441\u0438\u0440\u0432\u0430\u043d\u043d\u044b\u0435 \u043f\u0435\u043d\u0438 (\u0440\u0430\u0441\u0445\u043e\u0434\u044b) 22803 \u043e\u0442 26.11.2019; 22804 \u043e\u0442 05.12.19\n\n1. \u0421\u043a\u043e\u043c\u043f\u0435\u043d\u0441\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u043d\u0435 \u0437\u0430\u043a\u0440\u044b\u0442\u044b\u0435 \u0434\u043e\u043b\u0433\u0438;\n2. \u0412\u043a\u043b\u044e\u0447\u0430\u0442\u044c \u0440\u0438\u0441\u043a \u0437\u0430 \u043f\u0440\u043e\u0441\u0440\u043e\u0447\u043a\u0443.\n\u041f\u043e\u043b\u0438\u0441\u0442\u0438\u0440\u043e\u043b \u0422\u041f \u043c\u0430\u0440\u043a\u0430 \u0411\t\t8,75 \u0442\n\u0426\u0435\u043d\u0430 \u043f\u0440\u043e\u0434\u0430\u0436\u0438   153\u00a0290,00  \u041e\u0442\u0441\u0440\u043e\u0447\u043a\u0430  3\u00a0100,00  \u0427\u0438\u0441\u0442\u0430\u044f \u0446\u0435\u043d\u0430  150\u00a0190,00 (\u0420\u0430\u0441\u0447\u0435\u0442\u043d\u0430\u044f \u0441\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u044c \u043e\u0442\u0441\u0440\u043e\u0447\u043a\u0438 6\u00a0092,96)\n\u041f\u043e\u043b\u0438\u0441\u0442\u0438\u0440\u043e\u043b 825\t\t1 \u0442\n\u0426\u0435\u043d\u0430 \u043f\u0440\u043e\u0434\u0430\u0436\u0438   153\u00a0400,00  \u041e\u0442\u0441\u0440\u043e\u0447\u043a\u0430  3\u00a0100,00  \u0427\u0438\u0441\u0442\u0430\u044f \u0446\u0435\u043d\u0430  150\u00a0300,00 (\u0420\u0430\u0441\u0447\u0435\u0442\u043d\u0430\u044f \u0441\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u044c \u043e\u0442\u0441\u0440\u043e\u0447\u043a\u0438 6\u00a0097,33)\n\u041f\u043e\u043b\u0438\u0441\u0442\u0438\u0440\u043e\u043b 825 \u0415S\t\t10,25 \u0442\n\u0426\u0435\u043d\u0430 \u043f\u0440\u043e\u0434\u0430\u0436\u0438   153\u00a0400,00  \u041e\u0442\u0441\u0440\u043e\u0447\u043a\u0430  3\u00a0100,00  \u0427\u0438\u0441\u0442\u0430\u044f \u0446\u0435\u043d\u0430  150\u00a0300,00 (\u0420\u0430\u0441\u0447\u0435\u0442\u043d\u0430\u044f \u0441\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u044c \u043e\u0442\u0441\u0440\u043e\u0447\u043a\u0438 6\u00a0097,33)\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0430\u0432\u043a\u0438: \u0410\u0432\u0433\u0443\u0441\u0442 2021 \u0433.\n\u0422\u0438\u043f\u043e\u0432\u044b\u0435 \u0443\u0441\u043b\u043e\u0432\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b: \u041e\u0442\u0441\u0440\u043e\u0447\u043a\u0430 30 \u0434\u043d\u0435\u0439 (\u0444\u0430\u043a\u0442\u043e\u0440\u0438\u043d\u0433)\n\u0421\u0447\u0435\u0442: 7435 \u0424\u0418\u041b\u0418\u0410\u041b "\u041d\u0418\u0416\u0415\u0413\u041e\u0420\u041e\u0414\u0421\u041a\u0418\u0419" \u0410\u041e "\u0410\u041b\u042c\u0424\u0410-\u0411\u0410\u041d\u041a", \u041a\u0430\u0440\u0442\u043b\u0438 \u0420\u0443\u0441 \u041e\u041e\u041e (RUB)\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430: \u0421\u0430\u043c\u043e\u0432\u044b\u0432\u043e\u0437 (\u0441 \u043d\u0430\u0448\u0435\u0433\u043e \u0441\u043a\u043b\u0430\u0434\u0430)\n\u0414\u0435\u0431\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c (\u043f\u043e \u043f\u043e\u0434\u0440\u0430\u0437\u0434\u0435\u043b\u0435\u043d\u0438\u044e / \u043e\u0431\u0449\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c / \u043d\u0435\u0437\u0430\u0447\u0442\u0435\u043d\u043e):  37\u00a0160\u00a0000 / 37\u00a0160\u00a0000 / 0\n\u041e\u0421\u0422\u0410\u0422\u041e\u041a \u041b\u0418\u041c\u0418\u0422\u0410 22\u00a0130\u00a0000\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f: \u043d\u0430\u0446\u0435\u043d\u043a\u0430 2,5 \u0440\u0443\u0431\n\u043e\u0442\u043f \u0444\u0430\u043a\u0442\u043e\u0440 30 \u0434\u043d\u0435\u0439',
        'Comment': '',
        'SegmentUponShipment': false,
        'ConfirmWithDirector': false,
        'ConfirmWithFinancier': false,
      },
      {
        'id': '6fec238e-ff33-11eb-80fd-a4bf016a73d1',
        'Number': '00-00009502006',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 \u041e\u041e\u041e "\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422" \u2116CH00-000190 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 CH00-000190 \u043e\u0442 17.08.2021 9:36:29',
        'Partner': '\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422 \u041e\u041e\u041e',
        'Author': '\u0428\u0435\u0440\u0435\u043c\u0435\u0442\u044c\u0435\u0432 \u0412\u0438\u043a\u0442\u043e\u0440',
        'INN': '5010056869',
        'Deadline': '2021-11-01T13:16:34',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a:\u042d\u041a\u041e\u041f\u041b\u0410\u0421\u0422 \u041e\u041e\u041e (\u0418\u041d\u041d/\u041a\u041f\u041f:5010056869/501001001) \u043d\u0430 \u0441\u043a\u043b\u0430\u0434 \u041f\u043e\u043b\u0438\u043c\u0435\u0440\u044b Kartli International (\u0442\u043e\u0432\u0430\u0440\u044b \u0432 \u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0438)\n\u0411\u043b\u043e\u043a-\u0441\u043e\u043f\u043e\u043b\u0438\u043c\u0435\u0440 \u0421\u0411\u0421-330\u0420\t\t6 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0619,00\n\u0411\u043b\u043e\u043a-\u0441\u043e\u043f\u043e\u043b\u0438\u043c\u0435\u0440 \u0421\u0411\u0421-330\u041b\t\t5 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0619,00\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f:\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430:\u041d\u0430 \u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0435 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0439 \u0441\u043b\u0443\u0436\u0431\u044b\n\u041a\u0440\u0435\u0434\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c:\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f:',
        'Comment': '',
      },
      {
        'id': '91e79e22-ff45-11eb-80fd-a4bf016a73d1',
        'Number': '00-00009506009',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 LUKOIL BENELUX B.V.  \u2116CH00-000191 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 CH00-000191 \u043e\u0442 17.08.2021 13:26:06',
        'Partner': 'LUKOIL BENELUX B.V.',
        'Author': '\u0413\u043b\u043e\u0442\u043a\u043e \u0421\u0432\u0435\u0442\u043b\u0430\u043d\u0430',
        'INN': '060609017 ',
        'Deadline': '2021-11-01T15:26:21',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a:LUKOIL BENELUX B.V. (\u0418\u041d\u041d/\u041a\u041f\u041f:) \u043d\u0430 \u0441\u043a\u043b\u0430\u0434 \u041f\u043e\u043b\u0438\u043c\u0435\u0440\u044b Kartli International (\u0442\u043e\u0432\u0430\u0440\u044b \u0432 \u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0438)\n\u041f\u043e\u043b\u0438\u043f\u0440\u043e\u043f\u0438\u043b\u0435\u043d \u0411\u0443\u043f\u043b\u0435\u043d 6531\t\t23,375 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0275,00\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f:\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430:\u041d\u0430 \u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0435 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0439 \u0441\u043b\u0443\u0436\u0431\u044b\n\u041a\u0440\u0435\u0434\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c:\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f:1 \u0430\u0432\u0442\u043e \u043d\u0430 \u0421\u0435\u0440\u0431\u0438\u044e (-300) \u043d\u0435\u0434\u0435\u043b\u044f 32',
        'Comment': '',
      },
      {
        'id': 'ccc8fa92-ff45-11eb-80fd-a4bf016a73d1',
        'Number': '00-00009507005',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 LUKOIL BENELUX B.V.  \u2116CH00-000192 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 CH00-000192 \u043e\u0442 17.08.2021 13:27:41',
        'Partner': 'LUKOIL BENELUX B.V.',
        'Author': '\u0413\u043b\u043e\u0442\u043a\u043e \u0421\u0432\u0435\u0442\u043b\u0430\u043d\u0430',
        'INN': '060609017 ',
        'Deadline': '2021-11-01T15:28:07',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a:LUKOIL BENELUX B.V. (\u0418\u041d\u041d/\u041a\u041f\u041f:) \u043d\u0430 \u0441\u043a\u043b\u0430\u0434 \u041f\u043e\u043b\u0438\u043c\u0435\u0440\u044b Kartli International (\u0442\u043e\u0432\u0430\u0440\u044b \u0432 \u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0438)\n\u041f\u043e\u043b\u0438\u043f\u0440\u043e\u043f\u0438\u043b\u0435\u043d \u0411\u0443\u043f\u043b\u0435\u043d 6531\t\t23,375 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0275,00\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f:\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430:\u041d\u0430 \u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0435 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0439 \u0441\u043b\u0443\u0436\u0431\u044b\n\u041a\u0440\u0435\u0434\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c:\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f:1 \u0430\u0432\u0442\u043e \u043d\u0430 \u0421\u0435\u0440\u0431\u0438\u044e (-300) \u043d\u0435\u0434\u0435\u043b\u044f 32',
        'Comment': '',
      },
      {
        'id': '10819706-ff46-11eb-80fd-a4bf016a73d1',
        'Number': '00-00009508005',
        'Name': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c: \u0437\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 LUKOIL BENELUX B.V.  \u2116CH00-000193 \u043e\u0442 17.08.2021',
        'Object': '\u0417\u0430\u043a\u0430\u0437 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443 CH00-000193 \u043e\u0442 17.08.2021 13:29:37',
        'Partner': 'LUKOIL BENELUX B.V.',
        'Author': '\u0413\u043b\u043e\u0442\u043a\u043e \u0421\u0432\u0435\u0442\u043b\u0430\u043d\u0430',
        'INN': '060609017 ',
        'Deadline': '2021-11-01T15:29:54',
        'WayPoints': [],
        'BusinessProcess': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430 \u043f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a\u0443',
        'TaskType': '\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u0442\u044c',
        'Description': '\u041f\u043e\u0441\u0442\u0430\u0432\u0449\u0438\u043a:LUKOIL BENELUX B.V. (\u0418\u041d\u041d/\u041a\u041f\u041f:) \u043d\u0430 \u0441\u043a\u043b\u0430\u0434 \u041f\u043e\u043b\u0438\u043c\u0435\u0440\u044b Kartli International (\u0442\u043e\u0432\u0430\u0440\u044b \u0432 \u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0438)\n\u041f\u043e\u043b\u0438\u043f\u0440\u043e\u043f\u0438\u043b\u0435\u043d \u0411\u0443\u043f\u043b\u0435\u043d 6131 \t\t70,125 \u0442    \u043f\u043e \u0446\u0435\u043d\u0435    1\u00a0360,00\n\u0421\u0440\u043e\u043a \u043f\u043e\u0441\u0442\u0443\u043f\u043b\u0435\u043d\u0438\u044f:\n\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430:\u041d\u0430 \u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u0438\u0435 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0439 \u0441\u043b\u0443\u0436\u0431\u044b\n\u041a\u0440\u0435\u0434\u0438\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u044c:\n\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f:3 \u0430\u0432\u0442\u043e \u043d\u0430 \u0420\u0443\u043c\u044b\u043d\u0438\u044e (-300) \u043d\u0435\u0434\u0435\u043b\u044f 33',
        'Comment': '',
      },
      {
        'id': 'ad5a0de8-ff34-11eb-80fd-a4bf016a73d1',
        'Number': '00-00223800011',
        'Name': '\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043e \u0438\u0437\u043c\u0435\u043d\u0435\u043d\u0438\u0435 \u0443\u0441\u043b\u043e\u0432\u0438\u0439 \u043f\u0440\u043e\u0434\u0430\u0436 KROKODIL & COMPANY D.O.O',
        'Object': 'KROKODIL & COMPANY D.O.O (\u041f\u0430\u0440\u0442\u043d\u0435\u0440)',
        'Partner': 'KROKODIL & COMPANY D.O.O',
        'Author': '\u0421\u0430\u0442\u0442\u0430\u0440\u043e\u0432\u0430 \u041c\u0430\u0440\u0438\u044f',
        'INN': '107036503',
        'Deadline': '2021-11-01T19:04:32',
        'WayPoints': [],
        'BusinessProcess': '\u0418\u0437\u043c\u0435\u043d\u0435\u043d\u0438\u0435 \u0443\u0441\u043b\u043e\u0432\u0438\u0439 \u043f\u0440\u043e\u0434\u0430\u0436',
        'TaskType': '\u041e\u0437\u043d\u0430\u043a\u043e\u043c\u0438\u0442\u044c\u0441\u044f',
        'Description': ' Order Confirmation\n \u0422\u0435\u043a\u0443\u0449\u0438\u0439 \u0441\u0440\u043e\u043a \u043e\u0442\u0441\u0440\u043e\u0447\u043a\u0438 : 30 \u043a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u043d\u044b\u0445 \u0434\u043d\u0435\u0439 \n \u041b\u0438\u043c\u0438\u0442 \u0434\u0435\u0431\u0438\u0442\u043e\u0440\u0441\u043a\u043e\u0439 \u0437\u0430\u0434\u043e\u043b\u0436\u0435\u043d\u043d\u043e\u0441\u0442\u0438 : 200\u00a0000 \n \u041e\u0441\u0442\u0430\u0442\u043e\u043a \u043b\u0438\u043c\u0438\u0442\u0430 : 200\u00a0000 \n \u041a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439 : \u043f\u0440\u043e\u0448\u0443 \u0437\u0430\u043f\u0440\u043e\u0441\u0438\u0442\u044c \u0443 \u041a\u041e\u0424\u0410\u0421 \u0438 \u0443\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c \u043b\u0438\u043c\u0438\u0442 200\u00a0000 \u0435\u0432\u0440\u043e \u0434\u043e 30 \u043a\u0434\n \u0417\u0430\u043f\u0440\u0430\u0448\u0438\u0432\u0430\u0435\u043c\u044b\u0439 \u043b\u0438\u043c\u0438\u0442 \u0438 \u0441\u0440\u043e\u043a \u043e\u0442\u0441\u0440\u043e\u0447\u043a\u0438 : \u041f\u043e \u043e\u0442\u0441\u0440\u043e\u0447\u043a\u0435 \u043f\u043b\u0430\u0442\u0435\u0436\u0430 200\u00a0000 EUR (30)\n\u0421\u0443\u043c\u043c\u0430 \u0441\u0442\u0440\u0430\u0445\u043e\u0432\u043a\u0438 : 200\u00a0000 EUR',
        'Comment': '',
      },
    ],
    data_loading: true,
    current_data: [],
    current_data_calc: [],
    task_types: [],
    input_field_comment: undefined,
    task_form: {
      selected_item: undefined,
      is_button_loading_main: false,
      is_button_loading_additional: false,
      status: undefined,
      date: undefined,
      error_text_comment: '',
      error_text: '',
      success_text: '',
    },
    testMode: false,
  }),
  mounted() {
    this.testMode = this.$store.getters.isGroup('Тестовый режим согласования задач руководителей');
    this.renew_data();
  },
  methods: {
    confirmFormDirector(data) {
      this.task_form.selected_item['ConfirmWithDirector']=data;
    },
    confirmFormFinancier(data) {
      this.task_form.selected_item['ConfirmWithFinancier']=data;
    },
    confirmFormSegmentUponShipment(data) {
      this.task_form.selected_item['SegmentUponShipment']=data;
    },
    set_comments(data) {
      this.input_field_comment=data;
    },
    get_string_date(dateISO) {
      const date = new Date(dateISO);
      return `${date.getDate()} ${date.toLocaleString('ru-RU', {month: 'long'})}`.replace(/ноябрь/g, 'ноября');
    },
    renew_data() {
      this.loadingTasks = true;
      if (!this.testMode) {
        const options={
          url: `${ROOT_URL}/api/v1/src/Internal__Sellers__GetTask`,
          method: 'POST',
          body: {
            params: {},
          }};
        dataRequester(options).then((data)=>{
          this.loadingTasks = false;
          this.compute_data(data.result.data);
        }).catch(()=>{});
      } else {
        this.loadingTasks = false;
        this.compute_data(this.presentationData);
      }
    },
    compute_data(data) {
      this.current_data = data;
      this.task_types = [...new Set( this.current_data.map((item) => item['BusinessProcess']))];
      this.data_loading = false;
      this.current_data_calc = this.current_data;
    },
    click_by_card(item) {
      this.task_form.selected_item = item;
      this.$refs.modalViewConductor.up_level();
    },
    closed_modal() {
      this.task_form.error_text_comment=undefined;
      this.clicked_item_data = undefined;
    },
    send_comment(isApprove) {
      if (!this.input_field_comment && !isApprove) {
        this.task_form.error_text_comment = 'Для выполнения действия данное поле должно быть заполнено';
        return false;
      }

      if (this.testMode) {
        window.globalEvents.callEvent('new_message', [{
          messageType: 'warning',
          messageData: 'Невозможно согласовать заказ в режиме презентации',
        }]);
        this.task_form.is_button_loading_main = false;
        this.task_form.is_button_loading_additional = false;
        return;
      }

      // создаём новый объект data с нужными полями из объекта-формы task_form.selected_item
      const {id, ConfirmWithDirector, ConfirmWithFinancier, SegmentUponShipment} = this.task_form.selected_item;
      const data = {id, ConfirmWithDirector, ConfirmWithFinancier, SegmentUponShipment,
        Comment: this.input_field_comment, Approved: isApprove};
      if (isApprove) this.task_form.is_button_loading_main = true;
      else this.task_form.is_button_loading_additional = true;
      const options={
        url: `${ROOT_URL}/api/v1/src/Internal__Sellers__ApproveTask`,
        method: 'POST',
        body: {
          params: data,
        }};

      dataRequester(options)
          .then((data)=>{
            if (data.status === 200) {
              window.location.reload(true);
              /* window.globalEvents.callEvent('new_message', [{
                messageType: 'success',
                messageData: 'Решение принято',
              }]); */
            } else {
              // обработка ошибок
              window.globalEvents.callEvent('new_message', [{
                messageType: 'error',
                messageData: {
                  message: 'Нештатный ответ от сервера!'},
              }]);
              console.error('Внимание! Неожиданый ответ от сервера!');
            }
          })
          .catch((errorObj)=>{})
          .finally( ()=>{
            this.task_form.is_button_loading_main = false;
            this.task_form.is_button_loading_additional = false;
          });
    },
  },
});
</script>

<style lang="less">
@import url('../../assets/v1/less/base.less');

.text_hint {
  color: @gray;
}

.card{
  &__header{
    .flex(row, space-between, center);
  }
}

.task_types {
  .flex(column, flex-start, stretch);
  & > *{
    margin-bottom: 24px;
  }

  & > *:last-child{
    margin-bottom: 0;
  }

  &__group {
    .flex(column, flex-start, stretch);
    & > *{
      margin-bottom: 12px;
    }

    & > *:last-child{
      margin-bottom: 0;
    }
  }
}

.error_text {
  color: @error;
}

.success_text {
  color: @green;
}

.modal-button {
  width: 100%;
  &-panel {
    .flex(row, flex-start, center);
    & > *{
      margin-right: 6px;
    }

    & > *:last-child{
      margin-right: 0;
    }
  }
}

</style>
